/** Classes communes aux champs de saisie — un seul aspect pour tous. */

import { cn } from '../lib/cn'

const BASE_CHAMP =
  'block w-full rounded-md bg-white px-3 text-sm text-slate-900 shadow-sm ring-1 ring-inset ' +
  'transition-colors placeholder:text-slate-500 disabled:cursor-not-allowed ' +
  'disabled:bg-slate-100 disabled:text-slate-500'

export function classesChamp(invalide = false, hauteurAuto = false): string {
  return cn(
    BASE_CHAMP,
    // 44 px au doigt, 40 px à la souris — même arbitrage que `Button`.
    hauteurAuto ? 'py-2' : 'h-11 sm:h-10',
    invalide
      ? 'ring-red-500 focus-visible:outline-red-600'
      : 'ring-slate-300 hover:ring-slate-400',
  )
}
